"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = require("../../../utils");
var NUMBER_REGEXP = /^([-]?[0-9]+)?$/;
exports.integerValidator = {
    name: 'integer',
    validation: function (value) {
        var valueWithoutWhitespace = utils_1.isDefined(value) ? String(value).replace(utils_1.WHITESPACE_PATTERN, '') : value;
        return utils_1.isEmpty(valueWithoutWhitespace) || NUMBER_REGEXP.test(valueWithoutWhitespace);
    },
    formatter: function (value) {
        var newValue = value;
        if (newValue.length > 0) {
            newValue = newValue
                .toString()
                .replace(utils_1.WHITESPACE_PATTERN, '')
                .replace(utils_1.FORMAT_3_DIGITS_GROUPS, ' ');
        }
        return newValue;
    },
};
//# sourceMappingURL=IntegerValidator.js.map